import React, { useState,useEffect, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./profile.css";
import PersonalInfoComponent from "./profile.personal.component";
import ProfessionalInfoComponent from "./profile.professional.component";
import EducationalInfoComponent from "./profile.educational.component";


const ProfileFormComponent = () => {

  const [selectedNav, setSelectedNav] = useState("personalInfo");

  return (
    <div className="layout">
     
      {/* Personal Information Form start */}
      <input
        name="nav"
        type="radio"
        className="nav profile-tab personalInfo-radio"
        id="personalInfo"
        checked={selectedNav === "personalInfo"}
        onChange={() => setSelectedNav("personalInfo")}
      />
      <div className="page personalInfo-page">

        <div className="page-contents">
          <div className="profile-contents personal-info-inputs">
              <PersonalInfoComponent/>
          </div>
        </div>
      </div>
      <label className="nav" htmlFor="personalInfo">
        <span>Personal</span>
      </label>
      {/* Personal Information Form end */}
      

      {/* Professional Information Form start*/}
      <input
        name="nav"
        type="radio"
        className="nav profile-tab professionalInfo-radio"
        id="about"
        checked={selectedNav === "about"}
        onChange={() => setSelectedNav("about")}
      />

       <div className="page about-page">
        <div className="page-contents">
        <div className="profile-contents professional-info-inputs">
        <ProfessionalInfoComponent/>
        </div>
     
        </div>
      </div>

      <label className="nav" htmlFor="about">
        <span>Professional Experience</span>
      </label>
     {/* Professional Information Form  end*/}



      {/* Education Information Forme  start*/}
      <input
        name="nav"
        type="radio"
        className="nav profile-tab educationalInfo-radio"
        id="contact"
        checked={selectedNav === "contact"}
        onChange={() => setSelectedNav("contact")}
      />
      <div className="page contact-page">
        <div className="page-contents">
          <div className="profile-contents educational-info-inputs">
           <EducationalInfoComponent/>
          </div>
        </div>
      </div>
      <label className="nav" htmlFor="contact">
        <span>Academic Qualification</span>
      </label>
  {/* Education Information Formee  End*/}



    </div>
  );
};

export default ProfileFormComponent;


